export let AccountType;

(function (AccountType) {
  AccountType["Personal"] = "personal";
  AccountType["Business"] = "business";
})(AccountType || (AccountType = {}));

export let DocumentGroup;

(function (DocumentGroup) {
  DocumentGroup["IdentityDocuments"] = "identity_documents";
  DocumentGroup["SupportingDocuments"] = "supporting_documents";
})(DocumentGroup || (DocumentGroup = {}));